import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=08ba5c31"
import script from "./Membership.vue?vue&type=script&lang=js"
export * from "./Membership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports